import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { attach } from "../../common/componentExtensions";
import Form from "./changeCompanyForm";
import Actions from "../esercentiActions";
import Store from "../loginStore";
import { links } from "../../routes";
import { CompanyDataDto, CompanyDto } from "../../generated";


interface Props extends RouteComponentProps<{}> {
    esercente: CompanyDto;
}
const CompanyEditPage = (props: Props) => {

    const { esercente, history } = props;


    useEffect(() => {
        if (Store.getEsercente() == null)
            Actions.getEsercente();
    }, [])
    const save = async (data: CompanyDataDto) => {
        await Actions.update(+props.esercente.id, data);
        history.push(links.home);
    }

    return (
        <div className="card">
            <div className="card-body pb-0">
                <Form
                    esercente={esercente}
                    onSubmit={save}
                    onCancel={() => history.goBack()}
                />
            </div>
        </div>
    );
}


export default withRouter(attach(CompanyEditPage, Store, (store, props) => ({ esercente: store.getEsercente()! })));